import { useIsMobile } from "../../hooks/useIsMobile";
import React, { useEffect, useState } from "react";
import AuthorListPage from "./AuthorListPage";
import { getAuthors } from "../../api/index";
import { useLoading } from "../../common/controls/LoadingContext";
import usePageTitle from "../../hooks/usePageTitle";


const AuthorContainer = () => {
    usePageTitle("북밋 작가 리스트");
    const isMobile = useIsMobile();
    const [authors, setAuthors] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState<number>(1);
    const { showLoading, hideLoading } = useLoading();

    const [filters, setFilters] = useState<{ array: string[]; genre: string[]; textType: string[] }>({
        array: [],
        genre: [],
        textType: [],
    });

    const handleFilterChange = (newFilters: { array: string[]; genre: string[]; textType: string[] }) => {

        setFilters(newFilters);
        setCurrentPage(1);
    };


    useEffect(() => {
        const fetchAuthors = async () => {
            try {
                showLoading();
                const data = await getAuthors(currentPage, itemsPerPage, filters);
                setAuthors(data.content);
                setTotalPages(data.totalPages);
            } catch (error) {
                console.error("Error fetching authors:", error);
            } finally {
                hideLoading();
            }
        };

        fetchAuthors();
    }, [currentPage, itemsPerPage, filters]); // 필터가 바뀌면 재호출됨

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };



    return (
        <>
            <AuthorListPage
                authors={authors}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                filter={filters}
                onFilterChange={handleFilterChange}
            />
        </>
    )


}


export default AuthorContainer
